import styles from './ColumnManagement.module.css';

/**
 * ColumnManagement
 * @param {object} props
 * @param {import('react').ReactNode} props.leftChildren - Optional custom item renderer
 * @param {import('react').ReactNode} props.rightChildren - Optional custom item renderer
 * @param {import('react').ReactNode} props.children - Optional custom item renderer
 * @returns {JSX.Element} ColumnManagement component
 */
function ColumnManagement({
  leftChildren,
  rightChildren,
  children,
}) {
  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        {leftChildren}
        {rightChildren}
      </div>
      <div className={styles.footer}>
        {children}
      </div>
    </div>
  );
}

/**
 * ColumnManagementSection
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} ColumnManagementSection component
 */
function ColumnManagementSection({ children }) {
  return <div className={styles.section}>{children}</div>;
}

/**
 * ColumnManagementSectionList
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} ColumnManagementSectionList component
 */
function ColumnManagementSectionList({ children }) {
  return <div className={styles.list}>{children}</div>;
}

export {
  ColumnManagement, ColumnManagementSection, ColumnManagementSectionList,
};
